import { functions, db } from "./firebase";
import { httpsCallable } from "firebase/functions";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
  orderBy,
  Query,
} from "firebase/firestore";
/**
 * Call httpsCallable function
 */
const callFunc = async <T>(func: string, ...args: any[]): Promise<T> => {
  const result = await httpsCallable<unknown, T>(functions, func)(...args);
  console.log("Result", result);
  return result?.data;
};

const getDocuments = async <T>(docCollection: string): Promise<T> => {
  const q = query(collection(db, docCollection));
  return getDocs(q)
    .then((querySnapshot) => {
      if (querySnapshot.docs.length) {
        const data: any = [];
        querySnapshot.docs.forEach((doc) => {
          if (doc.exists()) {
            data.push({ ...(doc.data() as any), id: doc.id });
          }
        });
        return data;
      } else {
        console.log(`No ${docCollection} Available`);
        return null;
      }
    })
    .catch((error: any) => {
      console.log(error);
      throw new Error(`Server Failed to Fetch ${docCollection}`);
    });
};

const getDocument = async <T>(collection: string, id: string) => {
  const docRef = doc(db, collection, id);
  const docSnap = await getDoc(docRef);
  let data = docSnap.exists() ? docSnap.data() : [];
  return data;
};

const matchingGame = {
  getScores: async () => {
    return callFunc("matchingGame-getScores");
  },
};

const wof = {
  saveLead: async (data: any) => {
    return callFunc("wof-saveLead", data);
  },
};

const selfie = {
  saveLead: async (data: any) => {
    return callFunc("selfie-saveLead", data);
  },
};

const forms = {
  submit: async (data: any) => {
    await callFunc("forms-submitLeadCaptureForm", {
      ...data,
      meta: { browser: window.navigator.userAgent },
    });
  },
};

const sessionsApi = {
  getByDate: async () => {
    return callFunc("sessions-getByDate");
  },
};
const screensaverApi = {
  get: async () => {
    return callFunc("screensaver-get");
  },
};

const announcementsApi = {
  get: async () => {
    return callFunc("announcements-get");
  },
};

const pagesApi = {
  getFormattedPages: async () => {
    return callFunc("pages-getAndFormatPages");
  },
};

export {
  forms,
  getDocument,
  matchingGame,
  getDocuments,
  wof,
  selfie,
  sessionsApi,
  screensaverApi,
  announcementsApi,
  pagesApi,
};
